<template>
  <div class="app-order-summary">
    <slot name="txtBefore"></slot>
    <div class="customer-data">
      <slot name="txtBeforePersonalData"><strong>Anschrift</strong></slot>
      <ShowPersonalData :customer="currentCustomer">
        <template v-for="slot in possibleChildSlotsFor('PersonalData')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </ShowPersonalData>
      <slot name="txtBeforePaymentInfo"><strong>Zahldaten</strong></slot>
      <div><slot name="txtPaymentInfo">Die Bezahlung erfolgt über dein FYVE Prepaid-Guthaben.</slot></div>
    </div>
    <div class="txt-summary-content-heading"><slot name="txtSummaryContentHeading">Deine Bestellung</slot></div>
    <div class="summary-content">
      <dyn-slot :slot-data="{ selectedOption: selected, activatedStatus: activatedStatusString }">
        <slot name="txtSummaryContent"></slot>
      </dyn-slot>
    </div>
    <div class="order-step" v-if="!isSuccessStep">
      <b-overlay class="btn-next-overlay" :show="loading" spinner-small>
        <b-button @click="next" :disabled="loading" class="btn-next" type="button" variant="primary">
          <slot name="btnNext">Jetzt Ersatz SIM-Karte bestellen</slot>
        </b-button>
      </b-overlay>
    </div>
    <slot name="txtAfter"></slot>
  </div>
</template>
<script>

import { BButton } from 'bootstrap-vue'
import slotProxy from '@/mixins/slotProxy'
import { mapMutations, mapGetters, mapActions } from 'vuex'
import ShowPersonalData from '@/components/process/generic/PersonalData/ShowPersonalData.vue'
export const stepName = 'summary'
export default {
  name: 'OrderSummary',
  components: { BButton, ShowPersonalData },
  data () {
    return {
      loading: false,
      paymentInformation: {
        paymentType: null
      }
    }
  },
  computed: {
    ...mapGetters('substituteSimCard', [
      'currentStep', 'selected', 'isActivatedBeforeDelivery'
    ]),
    isSuccessStep: function () {
      return this.currentStep === 'success'
    },
    activatedStatusString () {
      return (this.isActivatedBeforeDelivery) ? 'aktiv' : 'inaktiv'
    }
  },
  methods: {
    ...mapMutations('substituteSimCard', [
      'changeStep'
    ]),
    ...mapActions('substituteSimCard', [
      'orderSubstituteSimCard'
    ]),
    async next () {
      this.loading = true
      await this.orderSubstituteSimCard({ nextStep: this.nextStep })
      this.loading = false
    }
  },
  props: {
    nextStep: {
      type: String,
      default: 'success'
    },
    currentCustomer: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  mixins: [
    slotProxy()
  ]
}
</script>
